<style lang="less">
    .editSet {
        z-index: 3;
        position: absolute;
        .common {
            width: 100%;
            height: 100%;
        }
        .date {
            min-width: 100px;
        }
        .ivu-input-wrapper {
            height: 100%;
            > input {
                height: 100%;
            }
            .ivu-input.ivu-input-default {
                color: #222;
                background-color: #fff !important;
            }
        }
        .ivu-date-picker-rel {
            height: 100%;
            .ivu-input-wrapper {
                height: 100%;
                .ivu-input-icon {
                    height: 100%;
                    align-items: center;
                    justify-content: center;
                }
                > input {
                    height: 100%;
                }
            }
        }
        .ivu-select-dropdown {
            margin-top: 0;
        }

        .ivu-input-number {
            .ivu-input-number-input {
                color: #666;
                background-color: #fff;
            }
            .ivu-input-number-handler-wrap {
                background-color: #fff;
                .ivu-icon-ios-arrow-up:before {
                    background-image: url("../assets/caret-up-empty.svg") !important;
                }
                .ivu-icon-ios-arrow-down:before {
                    background-image: url("../assets/caret-down-empty.svg") !important;
                }
            }
        }
        .ivu-input-number-input-wrap {
            height: 100%;
            > input {
                height: 100%;
                display: block;
            }
        }
        .ivu-input-number-handler {
            height: 50%;
            .ivu-input-number-handler-up-inner {
                top: 0;
            }
        }
    }
</style>

<template>
    <div class="editSet" :style="{ top: initTop + 'px', left: initLeft + 'px', width: initWidth + 'px', height: initHeight + 'px' }">
        <InputNumber
            class="common"
            ref="percentInput"
            v-if="showPercent || showDuration"
            :max="maxNum"
            :min="0"
            :step="step"
            v-model="newNum"
            :formatter="fmt"
            :parser="parser"
        ></InputNumber>
        <InputNumber class="common" ref="numberInput" v-if="showNumber" :step="step" v-model="newNum" :active-change="false"></InputNumber>
        <Input class="common" ref="dateInput" v-if="showDate" v-model="date" @on-blur="dateInputBlur()"></Input>
        <!-- <DatePicker
            class="common date"
            size="small"
            v-if="showDate"
            :clearable="false"
            format="yyyy/MM/dd"
            type="date"
            :value="date"
            @on-change="changedate"
            placeholder="Select date"
        ></DatePicker> -->
    </div>
</template>

<script lang="ts">
    enum editSetType {
        date,
        percent,
        duration,
        number,
    }
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";

    @Component({})
    export default class EditSet extends Vue {
        newNum: any = 0;
        timeOffset: number = new Date(0).getTimezoneOffset();

        keyInput: boolean = false; //键盘输入

        fmt(value: any) {
            /**
             * 开始编辑以及右侧上下调整需要 格式化
             */
            if (!this.startFlag && this.keyInput) {
                this.keyInput = false;
                return value;
            } else if (this.startFlag) {
                this.$store.commit("setStatus", {
                    type: "startFlag",
                    data: false,
                });
            }

            if (this.showPercent) {
                if (typeof value === "string" && value.endsWith(".")) {
                    return value + "%";
                }
                let val = Number(value);
                let tmpStr = val.toString().split(".")[1];
                let oriLen = tmpStr ? tmpStr.length : 0;
                let fmtLen = this.numberFmt.slice(2, -1).length;
                let floatLen = oriLen > fmtLen ? fmtLen : oriLen;
                return val.toFixed(floatLen) + "%";
            } else if (this.showDuration) {
                /*
            if(this.numberFmt.indexOf('d') != -1 || this.numberFmt.indexOf('w') != -1){
                    if(typeof value === 'string' && value.endsWith('.')){
                        return value + 'd.';
                    }
                    let val = Number(value);
                    return val.toFixed(1) + " d."
            }else{
                if(typeof value === 'string' && value.endsWith('.')){
                        return value + 'd.';
                    }
                    let val = Number(value);
                    if(this.numberFmt.indexOf('[h]') != -1){
                            return val.toFixed(0)+ " h."
                    }else if(this.numberFmt.indexOf('[hh]') != -1){
                        return val.toFixed(1)+ " h."
                    }

            }
            */
                let suffix = {
                    w: this.lang == "zh" ? "周" : "w.",
                    d: this.lang == "zh" ? "天" : "d.",
                    h: this.lang == "zh" ? "小时" : "h.",
                };
                if (this.numberFmt.indexOf("h") != -1) {
                    if (typeof value === "string" && value.endsWith(".")) {
                        return value + suffix.d;
                    }
                    let val = Number(value);
                    if (this.numberFmt.indexOf("[h]") != -1) {
                        return val.toFixed(0) + " " + suffix.h;
                    } else if (this.numberFmt.indexOf("[hh]") != -1) {
                        return val.toFixed(1) + " " + suffix.h;
                    }
                } else if (this.numberFmt.indexOf("d") != -1) {
                    if (typeof value === "string" && value.endsWith(".")) {
                        return value + suffix.d;
                    }
                    let val = Number(value);
                    return val.toFixed(1) + " " + suffix.d;
                } else {
                    if (typeof value === "string" && value.endsWith(".")) {
                        return value + suffix.d;
                    }
                    let val = Number(value);
                    return value.toFixed(1) + " " + suffix.w;
                }
            }
        }
        parser(value: string) {
            this.keyInput = true;

            if (this.showPercent) {
                let val = value.replace("%", "");
                return val;
            } else if (this.showDuration) {
                return value.replace(/ [a-z]\./, "");
                // if(this.numberFmt.indexOf('d') == -1 && this.numberFmt.indexOf('h') != -1){
                //         return (Number(value.replace(/ [a-z]\./,''))*60/this.numberAddInfo).toString();
                // }else{
                //         return value.replace(/ [a-z]\./,'');
                // }
            }
        }
        changedate(time) {
            let offset = this.timeOffset;
            let float = this.dateStamp - Math.floor(this.dateStamp);
            let num = Number(new Date(time));
            let minus = this.dateMinus && !float ? 1 : 0;
            let val = (num / 60000 - offset) / 1440 + 25569 + minus;
            console.log(parseInt(val.toFixed(0)) + float);
            this.$store.commit("setStatus", {
                type: "newDate",
                data: parseInt(val.toFixed(0)) + float,
            });
        }
        dateInputBlur() {
            this.$store.commit("setStatus", {
                type: "showDate",
                data: false,
            });
        }
        get step() {
            if (this.showPercent) {
                return 1;
            } else if (this.showDuration) {
                if (this.numberFmt.indexOf("d") == -1 && this.numberFmt.indexOf("h") != -1) {
                    return parseFloat(((1 / this.numberAddInfo) * 60).toString());
                }
            }
            return 1;
        }
        get maxNum() {
            if (this.showPercent) {
                return 100;
            }
            if (this.showDuration) {
                if (this.numberFmt.indexOf("d") == -1 && this.numberFmt.indexOf("w") != -1) {
                    return 17144 / 7;
                }
                if (this.numberFmt.indexOf("h") != -1) {
                    return (17144 * this.numberAddInfo) / 60;
                }
                return 17144;
            }
        }
        get number() {
            return this.$store.state.ui.editNumber.value;
        }

        get startFlag() {
            return this.$store.state.ui.startFlag;
        }
        // set number(value: number) {
        //     this.$store.commit("setStatus", {
        //         type: "editNumber",
        //         data: {
        //             value,
        //             fmt: this.numberFmt
        //         }
        //     });
        // }
        get numberFmt() {
            return this.$store.state.ui.editNumber.format;
        }
        get numberAddInfo(): any {
            return this.$store.state.ui.editNumberAddInfo;
        }
        get dateStamp() {
            return this.$store.state.ui.editDateStamp;
        }
        get date() {
            let date = this.dateStamp;
            console.log("date**************", date);
            let offset = this.timeOffset;
            let minus = this.dateMinus ? 1 : 0;
            let newDate = ((date - 25569) * 1440 + offset - minus) * 60000;
            //以下的三行代码就是日期格式去除时分秒格式，例如2020-11-30 21：22：00 变成2020-11-30
            //目的：防止直接对甘特图文本编辑完成时，日期+1导致时间不对
            // let processDate = new Date(newDate).toLocaleString().replace(/[\u4e00-\u9fa5]/g, '');
            let processDate = new Date(newDate).toLocaleDateString().replace(/[\u4e00-\u9fa5]/g, "");
            let removeTime = processDate.split(" ")[0];
            return removeTime;
            // return new Date(newDate).toLocaleString().replace(/[\u4e00-\u9fa5]/g, '');
        }
        set date(time) {
            let testTime: any = new Date(time);
            if (testTime == "Invalid Date") return;
            let offset = this.timeOffset;
            let float = this.dateStamp - Math.floor(this.dateStamp);
            let num = Number(new Date(time));
            let minus = this.dateMinus && !float ? 1 : 0;
            let val = (num / 60000 - offset) / 1440 + 25569 + minus;
            this.$store.commit("setStatus", {
                type: "newDate",
                data: parseInt(val.toFixed(0)) + float,
            });
        }
        get showDate() {
            this.$nextTick(() => {
                let dom = this.$refs.dateInput as HTMLElement;
                dom && dom.focus();
            });
            return this.$store.state.ui.showDate;
        }
        get showPercent() {
            return this.$store.state.ui.showNumber == editSetType.percent;
        }
        get showDuration() {
            return this.$store.state.ui.showNumber == editSetType.duration;
        }
        get showNumber() {
            return this.$store.state.ui.showNumber == editSetType.number;
        }
        get dateMinus() {
            return this.$store.state.ui.dateMinus;
        }
        get initTop() {
            return this.$store.state.ui.editRect.top;
        }
        get initLeft() {
            return this.$store.state.ui.editRect.left;
        }
        get initWidth() {
            return this.$store.state.ui.editRect.width;
        }
        get initHeight() {
            return this.$store.state.ui.editRect.height;
        }

        @Watch("showPercent")
        togglePerShow(val: boolean, oldVal: boolean) {
            if (val && !oldVal) {
                this.newNum = this.number * 100;
                this.$nextTick(() => {
                    let el = this.$refs["percentInput"]["$el"];
                    el.querySelector("input").focus();
                });
            }
        }

        @Watch("showDuration")
        toggleDurShow(val: boolean, oldVal: boolean) {
            if (val && !oldVal) {
                /*
            if(this.numberFmt.indexOf('d') != -1 || this.numberFmt.indexOf('w') != -1){
                this.newNum = this.number
            }else{
                this.newNum = parseFloat((this.number * (this.numberAddInfo)/60).toString());
            }
            */

                if (this.numberFmt.indexOf("h") != -1) {
                    this.newNum = parseFloat(((this.number * this.numberAddInfo) / 60).toString());
                } else if (this.numberFmt.indexOf("d") != -1) {
                    this.newNum = parseFloat(this.number.toString());
                } else {
                    this.newNum = parseFloat((this.number / 7).toString());
                }
                this.$nextTick(() => {
                    let el = this.$refs["percentInput"]["$el"];
                    el.querySelector("input").focus();
                });
            }
        }

        @Watch("showNumber")
        toggleNumShow(val: boolean, oldVal: boolean) {
            this.newNum = this.number;
            this.$nextTick(() => {
                let el = this.$refs["numberInput"]["$el"];
                el.querySelector("input").focus();
            });
        }

        mounted() {
            (<any>this).$bus.$on("editedNum", () => {
                let v = this.newNum;
                if (!this.showNumber) {
                    if (typeof v === "string" && v.endsWith(".")) {
                        v = Number(v.slice(0, -1));
                    }
                }

                if (this.showPercent) {
                    v = v / 100;
                    this.$store.commit("setStatus", {
                        type: "editNumber",
                        data: {
                            value: v,
                            format: this.numberFmt,
                        },
                    });
                } else if (this.showDuration) {
                    /*
                if(this.numberFmt.indexOf('d') == -1 && this.numberFmt.indexOf('h') != -1){
                         v= (v*60/this.numberAddInfo).toString();
                }
                */

                    if (this.numberFmt.indexOf("h") != -1) {
                        v = (v * 60) / this.numberAddInfo;
                    } else if (this.numberFmt.indexOf("d") == -1 && this.numberFmt.indexOf("w") != -1) {
                        v = Math.round(v * 7.0);
                    }

                    this.$store.commit("setStatus", {
                        type: "editNumber",
                        data: {
                            value: v,
                            format: this.numberFmt,
                        },
                    });
                } else if (this.showNumber) {
                    this.$store.commit("setStatus", {
                        type: "editNumber",
                        data: {
                            value: v,
                            format: this.numberFmt,
                        },
                    });
                }
            });
        }

        created() {}
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("editedNum");
        }
    }
</script>
